export default __webpack_public_path__ + "static/media/svg-4.99e8eaed.svg";